<template>
  <div>
    <Cargando v-if="isLoading" />
    <div class="space-y-4">
      <div>Seleccione el medio de pago que desea utilizar:</div>
      <div class="relative flex items-start" v-for="medio in mediosPago" :key="medio.id">
        <div class="flex h-5 items-center">
          <input :id="'radio-' + medio.id.trim().toLowerCase()" type="radio" v-model="medioPago"
            @change="$emit('input', medioPago)" :value="medio" :disabled="medioDisabled(medio)"
            :class="medioDisabled(medio) ? 'cursor-not-allowed' : 'cursor-pointer'" name="medio-pago"
            class="h-4 w-4 rounded-full border-gray-300 text-colescba-blue-600 transition duration-150 ease-in-out focus:ring-colescba-blue-500" />
        </div>
        <div class="ml-3 text-sm">
          <label :for="'radio-' + medio.id.trim().toLowerCase()" class="font-medium" :class="medioDisabled(medio)
              ? 'cursor-not-allowed text-gray-400'
              : 'cursor-pointer text-gray-700'
            ">
            <span>
              {{ medio.descripcion }}
            </span>
            <span v-if="medio.id.trim() == 'CTANOT'" :class="medioDisabled(medio) ? 'text-red-500' : 'text-gray-500'">
              ({{ saldo | currency }})
            </span>
            <span v-if="excedeMontoLimite(medio)" class="text-red-500">
              (excede el monto límite de {{ medio.monto_limite | currency }} establecido para este
              medio de pago)
            </span>
          </label>
        </div>
        <label v-if="medio.id.trim() == 'PNET'" :for="'radio-' + medio.id.trim().toLowerCase()"
          class="ml-2 rounded border border-yellow-400 bg-yellow-100 px-2 text-sm text-yellow-700">
          Nuevo
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useAcreditacionRolNotario, useAcreditacionServicio, useSession } from '@colescba/ui'

import Cargando from '@/components/Core/Cargando.vue'
import numeral from '@/util/numeral'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    monto: { type: [String, Number], required: false },
    tipoDeuda: { type: String, required: true },
  },

  components: { Cargando },

  mixins: [
    useService('portalPagos'),
    useSession(),
    useAcreditacionServicio(),
    useAcreditacionRolNotario(),
  ],

  data() {
    return {
      medioPago: null,
      mediosPagoAll: [],
      isLoading: true,
      algunMedioHabilitado: false,
    }
  },

  async mounted() {
    if (this.isValidadoNotario) {
      await this.actualizarSaldo({
        cuitCuil: this.user.cuitCuil.numero,
        portalPagos: this.portalPagos,
      })
    }

    this.mediosPagoAll = await this.portalPagos.getMediosPago(
      this.user.cuitCuil.numero,
      this.tipoDeuda,
    )
    this.actualizarPropMediosHabilitados()
    this.$emit('permitePagoElectronico:update', this.permitePagoElectronico)
    this.$emit('permitePagarMasTarde:update', this.permitePagarMasTarde)
    if (this.mediosPago.length === 1) {
      this.medioPago = this.mediosPago[0]
      this.$emit('input', this.medioPago)
    }
    this.isLoading = false
  },

  computed: {
    ...mapState({
      saldo: state => state.app.saldo,
    }),
    mediosPago() {
      if (this.isValidadoNotario) {
        return this.mediosPagoAll
      } else {
        return this.mediosPagoAll.filter(m => m.id.trim() != 'CTANOT')
      }
    },
    montoNumeral() {
      // numeral para cambiar de , a . como separador decimal
      return numeral(this.monto).value()
    },
    permitePagoElectronico() {
      return this.mediosPago.some(m => ['LINK', 'PMC'].includes(m.id.trim()))
    },
    permitePagarMasTarde() {
      return this.mediosPago.some(m => m.id.trim() == 'CTANOT')
    },
  },

  methods: {
    ...mapActions({
      actualizarSaldo: 'app/actualizarSaldo',
    }),

    medioDisabled(medio) {
      if (
        (medio.id.trim() == 'CTANOT' && this.montoNumeral > this.saldo) ||
        this.excedeMontoLimite(medio)
      ) {
        // PARCHE: si estaba seleccionado un medio de pago y se deshabilita, lo pongo en null
        if (this.medioPago?.id.trim() == medio.id.trim()) {
          this.medioPago = null
          this.$emit('input', this.medioPago)
        }
        return true
      }
      return false
    },
    excedeMontoLimite(medio) {
      return medio.monto_limite && this.montoNumeral > medio.monto_limite
    },
    actualizarPropMediosHabilitados() {
      this.algunMedioHabilitado = this.mediosPago.some(m => {
        if (m.id.trim() == 'CTANOT') {
          return this.montoNumeral <= this.saldo && !this.excedeMontoLimite(m)
        }
        return !this.excedeMontoLimite(m)
      })
      this.$emit('mediosHabilitados:change', this.algunMedioHabilitado)
    },
  },

  watch: {
    monto() {
      this.actualizarPropMediosHabilitados()
    },
  },
}
</script>
